<script lang="ts" setup>
import { TaskModel } from "@/components/tasks-kanban/models";
import { ListItemModel } from "../../../models";
import { computed, PropType } from "vue";
import { TaskCardItemWrapper } from "./";
import { formatDate } from "../services";

/**Параметры */
const props = defineProps({
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
});

/**Форматированная дата создания */
const dateCreate = computed(() => formatDate(props.task.DateCreate));
</script>
<template>
  <TaskCardItemWrapper :element="element">
    <span v-if="task.DateCreate" v-text="dateCreate" class="task-card-date-create" />
  </TaskCardItemWrapper>
</template>
<style lang="scss" scoped>
.task-card-date-create {
  font-size: 0.6875rem;
  font-weight: 400;
  color: var(--text-secondary);
}
</style>
